class RRObject {
  /**
   * @param {Record} obj to return AS NEW without undefined
   * @returns NEW object of param
   */
  static removeUndefined(obj: Record<string, unknown>): Record<string, unknown> {
    const clonedObject = Object.assign({}, obj);
    Object.keys(clonedObject).forEach((key) => clonedObject[key] === undefined && delete clonedObject[key]);
    return clonedObject;
  }

  /**
   * @param {Record} obj to return AS NEW without undefined. Undefined is removed with 'replacedWith'
   * @param replacedWith value to take over for the undefined values
   * @returns NEW object of param
   */
  static replaceUndefined<T extends any>(obj: T, replacedWith: any): T {
    const clonedObject: any = Object.assign({}, obj);
    Object.keys(clonedObject).forEach((key) => {
        if(clonedObject[key] === undefined) clonedObject[key] = replacedWith;
    });
    return clonedObject;
  }

  // Good luck getting rid of this JavaScript/TS any conflict. I won't be ANY help.
  /**
   * Helper function. Shouldn't be used outside of this file.
   *
   * @param {object} source object which will be left untouched
   * @param {object} target object which WILL BE MUTATED
   * @returns {object}
   */
  static _merge = (source: any, target: any): Record<any, unknown> => {
    return (
      void Object.keys(target).forEach((key) => {
        source[key] instanceof Object && target[key] instanceof Object
          ? source[key] instanceof Array && target[key] instanceof Array
            ? void (source[key] = Array.from(new Set(source[key].concat(target[key]))))
            : !(source[key] instanceof Array) && !(target[key] instanceof Array)
            ? void RRObject._merge(source[key], target[key])
            : void (source[key] = target[key])
          : void (source[key] = target[key]);
      }) || source
    );
  };

  /**
   * Merge input objects and return as new.
   * Both input params are NOT mutated.
   *
   * If objects have properties with primary types then input `a` takes precedense.
   * Nested objects and arrays are merged.
   *
   * @param a object to merge
   * @param b object to merge
   * @returns {object} combined version of input a and b
   */
  public static mergeObjects = (a: Record<any, unknown>, b: Record<any, unknown>): Record<any, unknown> => {
    const result = {...a};
    return RRObject._merge(b, result);
  };
}

export default RRObject;
